<template>
<div class="app-center">
  <heads></heads>
  <div class="app-range">
    <div class="app-icon">
      <div class="app-icon-img"><img :src="this.globalConfig.imgUrl+logo"/></div>
      <div class="app-icon-title">
        <!-- <div class="app-icon-name">{{$t('download.domain')}}</div>
         <div class="app-icon-name" style="color: #757575;font-size: 16px">{{$t('download.name')}}</div>-->
        <div class="app-icon-down" v-for="item in applist" @click.stop="_openApp(item.link)"><img src="../assets/img/ad.png" v-if="item.type==2"/>{{$t('download.app')}}</div>
      </div>
    </div>
    <div class="app-state">
      <div class="app-state-center">
        {{$t('download.num')}}<small >★★★★★</small><br>
        <small style=" margin-top: 10px;">{{$t('download.score')}}</small>
      </div>
      <div class="app-state-center">
        {{$t('download.edition')}}<br>
        <small style=" margin-top: 10px;">{{$t('download.style')}}</small>
      </div>
    </div>
    <div class="app-tit">
      <div class="app-tit-new">{{$t('download.new')}}<br><small>{{$t('download.time')}}</small></div>
      <ul>
        <li>{{$t('download.security')}}</li>
        <li>{{$t('download.speed')}}!</li>
        <li>{{$t('download.remember')}}!</li>
      </ul>
    </div>
    <div class="app-tit-icon"><img src="../assets/img/app-img.png"/> </div>
  </div>






</div>
</template>

<script>
  import heads from './navs/headr'
    export default {
        name: "download",
      components:{heads},
      data(){
          return{
            logo:'',
            username:'',
            balance:"",
            phone:'',
            withdraw_bet_quota:'',
            isToken:'',
            applist:[],
          }
      },
      created:function () {
          let _self=this;
          _self._config();
          _self._app();
      },
      methods:{

        _openApp:function(url){
          window.open(url)
        },
        _app:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'app/list', {}, function (result) {
            if(result.data['status_code']==200){
              _self.applist=result.data['data'];
            }
          })
        },

        _config:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'site/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.logo=result.data['data'].logo;
            }
          })
        },
      }
    }
</script>

<style scoped>
  .app-center{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    background-color: #212121;
    overflow-y: auto;
  }
  .app-range{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    max-width: 600px;
  }
  .app-icon{
    display: flex;
    width: 90%;
    margin: 20px auto;
    padding: 0;
  }
  .app-icon-img{
    display: block;

  }
  .app-icon-img img{
    width: 120px;
    height: auto;
  }
  .app-icon-title{
    display: block;
    margin-left: 20px;
    position: relative;
  }
  .app-icon-name{
    display: block;
    width: 100%;
    margin: 0 auto 10px;
    padding: 0;
    color: #ffffff;
    font-size: 150%;
  }
  .app-icon-down{
    display: flex;
    background-color: #95c11f;
    border-radius: 100px;
    line-height: 40px;
    padding: 0 15px;
    color: #ffffff;
    font-size: 16px;
    margin-top: 10px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .app-icon-down img{
    width: 20px;
    height: auto;
  }
  .app-state{
    display: flex;
    width: 90%;
    margin: 0 auto;
    padding: 20px 0;
    color: #bdbdbd;
    border-bottom: 1px solid #424242;
  }
  .app-state-center{
    font-size: 22px;
    font-weight: 400;
    width: 50%;
  }
  .app-state-center small{
    font-size: 15px;
    font-weight: 400;
    display: inline-block;

  }
  .app-tit{
    display: block;
    width: 90%;
    margin:15px auto;
    padding: 0;
  }
  .app-tit-new{
    color: #ffffff;
    margin-bottom: 5px;
    font-size: 25px;
  }
  .app-tit-new small{
    display: block;
    color: #757575;
    margin-top: 5px;
    font-size: 13px;
  }
  .app-tit ul{
    width: 100%;
    margin: 0 auto;
    padding: 0;
    color: #afafaf;
    display: block;
    line-height: 30px;
    font-size: 18px;
    list-style: none;
  }
  .app-tit ul li:before{
    content: '-';
    text-align: center;
    margin-right: 5px;
    box-sizing: border-box;
  }
  .app-tit-icon{
    display: block;
    width: 100%;

  }
  .app-tit-icon img{
    width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/download.vue